import { IAccessoryModel } from '../dataModels/ProductModels';
import * as style from './style.css';
import * as styleCard from '../style.css';
import { FuncT } from '../../../framework/framework/components/Types';
import ProductsSlider from '../../../components/productsSlider/ProductsSlider';
import { ProductService } from '../../../services/productService/ProductService';
import classes from '../../../framework/framework/tools/classes';

import React = require('react');

interface IProps {
    uriBuild: FuncT<string, string>;
    models: IAccessoryModel[];
}
interface IState {

}

export default class ModelAccessories extends React.Component<IProps, IState> {
    render() {
        return (
            <div className={style.accessoriesWrapper}>
                <div className={style.accessories}>
                    {this.relatives('Akcesoria')}
                    {this.relatives('Podobne')}
                    {this.relatives('Pakiety')}
                    {this.relatives('Inne')}

                </div>
            </div>
        );
    }

    relatives(type: string): React.ReactNode {
        const items = this.props.models.filter(x => x.accessoryType === type);
        if (items.length === 0) { return <></>; }

        return <div className={classes(styleCard.section)}>
            <h2 className={style.typeTitle} >{type}</h2>
            <div className={styleCard.bar}></div>
            <ProductsSlider
                models={items}
                buyClick ={(i, n) => this.handleItemBuy(i, n)}
            />
        </div>;
    }

    handleItemBuy(id: number, name: string): void {
        const productService = ProductService.Instance();
        productService.addToBasket(id, name, 1);
    }
}
